import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';
import { SelectButton } from 'primeng/selectbutton';

export interface SelectButtonFieldProps extends FormlyFieldProps {
  options?: any[];
  optionLabel?: string;
  optionValue?: string;
  allowEmpty?: boolean;
  size?: 'small' | 'large';
  styleClass?: string;
}

@Component({
  selector: 'SelectButton-field',
  standalone: true,
  imports: [...FORM_IMPORTS, SelectButton],
  template: `
    <p-select-button
      [formControl]="formControl"
      [formlyAttributes]="field"
      [options]="
        $any(props.options) ?? [
          { label: 'No', value: false },
          { label: 'Sì', value: true },
        ]
      "
      [optionLabel]="props.optionLabel ?? 'label'"
      [optionValue]="props.optionValue ?? 'value'"
      [allowEmpty]="props.allowEmpty ?? true"
      [size]="props.size ?? 'small'"
      [styleClass]="props.styleClass ?? ''"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectButtonFieldType extends FieldType<
  FieldTypeConfig<SelectButtonFieldProps>
> {}
